// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  /* color: #52616a; */
  min-height: 100vh;
}

.text-color {
  color: #52616a;
  overflow-wrap: break-word;
}

.modal-title {
  color: #52616a;
}

#welcome-screen nav {
  margin-bottom: 0;
}

.background-white {
  background: #fff;
}

.border-radius {
  border-radius: 0;
}

.navbar-brand {
  color: #fff !important;
  font-weight: 700;
  font-size: 16px;
}

.navbar-default {
  background: #fff;
  border: none;
  margin: 0;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  color: #000;
}

.navbar-default-new {
  background: #fff;
  border: none;
  margin: 0;
}

.navbar-default-new .navbar-nav > li > a {
  color: #000;
  font-weight: 700;
}

.navbar-default-new .navbar-nav > li > a:hover {
  color: rgb(159, 32, 137);
  background-color: #FFE7FB;
}

.navbar-default-new .navbar-nav > li > a:focus {
  color: rgb(159, 32, 137);
}

.navbar-default .navbar-nav > li > a {
  color: #fff;
  font-weight: 700;
}

.navbar-default .navbar-nav > li > a:hover {
  color: #fff;
}

#wrapper,
.container {
  width: 100%;
  /* background-color: #f5f5f5; */
}

.navbar-static-top {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1001;
}

.page-header {
  margin-top: 20px;
  font-size: 30px;
}

#wrapper nav {
  margin-bottom: 0;
}

.navbar-header {
  width: 180px;
}

.toggle-button {
  padding: 8px 10px;
  border-left: 1px solid #fff;
}

.sidebar {
  z-index: 1;
  position: absolute;
  /* border-top: 1px solid #fff; */
  width: 180px;
  height: 100vh;
  overflow: scroll;
  padding-bottom: 60px;
  overflow-y: scroll;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.sidebar-open {
  left: 0;
  top: 53px;
}

.sidebar-close {
  left: -180px;
}

.no-features-found {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #de7b7b;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

#menu_toggle {
  cursor: pointer;
  background: #fff;
  border: none;
  border-radius: 4px;
  text-align: center;
  padding: 4px 8px;
}

#menu_toggle .fa-bars {
  font-size: 18px;
}

#page-wrapper {
  min-height: calc(100vh);
  position: inherit;
  margin: 0 0 0 180px;
  padding: 52px 15px 30px;
  background-color: #f5f5f5;
}

#mt-16 {
  margin-top: 52px;
}
#wrapper.sidebarClosed #page-wrapper {
  margin: 0;
}

.padding-bottom-0 {
  padding-bottom: 0 !important;
}

.navbar-top-links {
  margin-right: 0;
}

.navbar-top-links li {
  display: inline-block;
}

.navbar-top-links li:last-child {
  margin-right: 15px;
}

.navbar-top-links li a {
  padding: 15px;
  min-height: 50px;
  font-size: 14px;
}

.navbar-top-links .dropdown-menu li {
  display: block;
}

.navbar-top-links .dropdown-menu li:last-child {
  margin-right: 0;
}

.menu-items-list ul {
  list-style: none;
  /* padding: 4px; */
}

.feature-name {
  margin-left: 4px;
  cursor: pointer;
  display: inline-block;
}

.feature-name:hover {
  margin-left: 4px;
  border: none !important;
  background-color: #fff;
}

.menu-items-list a:hover {
  background-color: #fff;
  /* color: #9F2089; */
}

.navbar-top-links .dropdown-menu li a {
  padding: 3px 20px;
  min-height: 0;
}

.navbar-top-links .dropdown-menu li a div {
  white-space: normal;
}

.navbar-top-links .dropdown-messages,
.navbar-top-links .dropdown-tasks,
.navbar-top-links .dropdown-alerts {
  width: 310px;
  min-width: 0;
}

.navbar-top-links .dropdown-messages {
  margin-left: 5px;
}

.navbar-top-links .dropdown-tasks {
  margin-left: -59px;
}

.navbar-top-links .dropdown-alerts {
  margin-left: -123px;
}

.navbar-top-links .dropdown-user {
  right: 0;
  left: auto;
}

.sidebar .sidebar-nav.navbar-collapse {
  padding-left: 0;
  padding-right: 0;
}

.sidebar .sidebar-search {
  padding: 15px;
}

.sidebar ul li {
  border-bottom: 1px solid #fff;
  width: 100%;
  padding: 4px;
}

.sidebar ul li a {
  color: #fff;
  font-size: 14px;
}

.sidebar ul li a:hover {
  background-color: rgb(159, 32, 137);
  color: #fff;
}

.sidebar ul li a.active {
  background-color: #fff;
  color: rgb(159, 32, 137);
  font-weight: 700;
}

.sidebar .arrow {
  float: right;
}

.sidebar .fa.arrow:before {
  content: '\\f104';
}

.sidebar .active > a > .fa.arrow:before {
  content: '\\f107';
}

.sidebar .nav-second-level li,
.sidebar .nav-third-level li {
  border-bottom: none !important;
}

.sidebar .nav-second-level li a {
  padding-left: 37px;
}

.sidebar .nav-third-level li a {
  padding-left: 52px;
}

.navbar-top-links .dropdown-messages,
.navbar-top-links .dropdown-tasks,
.navbar-top-links .dropdown-alerts {
  margin-left: auto;
}

.btn-outline {
  color: inherit;
  background-color: transparent;
  transition: all 0.5s;
}

.btn-primary.btn-outline {
  color: #428bca;
}

.btn-primary.btn-custom {
  color: #306CF5;
  background: #fff;
}

.btn-success.btn-outline {
  color: #5cb85c;
}

.btn-info.btn-outline {
  color: #5bc0de;
}

.btn-warning.btn-outline {
  color: #f0ad4e;
}

.btn-danger.btn-outline {
  color: #d9534f;
}

.btn-primary.btn-outline:hover,
.btn-success.btn-outline:hover,
.btn-info.btn-outline:hover,
.btn-warning.btn-outline:hover,
.btn-danger.btn-outline:hover {
  color: #fff;
}

.chat {
  margin: 0;
  padding: 0;
  list-style: none;
}

.chat li {
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px dotted #999;
}

.chat li.left .chat-body {
  margin-left: 60px;
}

.chat li.right .chat-body {
  margin-right: 60px;
}

.chat li .chat-body p {
  margin: 0;
}

.panel .slidedown .glyphicon,
.chat .glyphicon {
  margin-right: 5px;
}

.chat-panel .panel-body {
  height: 350px;
  overflow-y: scroll;
}

.login-panel {
  margin-top: 50px;
}

.flot-chart {
  display: block;
  height: 400px;
}

.flot-chart-content {
  width: 100%;
  height: 100%;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
  background: transparent;
}

table.dataTable thead .sorting_asc:after {
  content: '\\f0de';
  float: right;
  font-family: fontawesome;
}

table.dataTable thead .sorting_desc:after {
  content: '\\f0dd';
  float: right;
  font-family: fontawesome;
}

table.dataTable thead .sorting:after {
  content: '\\f0dc';
  float: right;
  font-family: fontawesome;
  color: rgba(50, 50, 50, 0.5);
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.428571429;
}

.btn-circle.btn-lg {
  width: 50px;
  height: 50px;
  padding: 10px 16px;
  border-radius: 25px;
  font-size: 18px;
  line-height: 1.33;
}

.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}

.show-grid [class^='col-'] {
  padding-top: 10px;
  padding-bottom: 10px;
  border: 1px solid #ddd;
  background-color: #eee !important;
}

.show-grid {
  margin: 15px 0;
}

.huge {
  font-size: 40px;
}

.panel-green {
  border-color: #5cb85c;
}

.panel-green > .panel-heading {
  border-color: #5cb85c;
  color: #fff;
  background-color: #5cb85c;
}

.panel-green > a {
  color: #5cb85c;
}

.panel-green > a:hover {
  color: #3d8b3d;
}

.panel-red {
  border-color: #d9534f;
}

.panel-red > .panel-heading {
  border-color: #d9534f;
  color: #fff;
  background-color: #d9534f;
}

.panel-red > a {
  color: #d9534f;
}

.panel-red > a:hover {
  color: #b52b27;
}

.panel-yellow {
  border-color: #f0ad4e;
}

.panel-yellow > .panel-heading {
  border-color: #f0ad4e;
  color: #fff;
  background-color: #f0ad4e;
}

.panel-yellow > a {
  color: #f0ad4e;
}

.panel-yellow > a:hover {
  color: #df8a13;
}

.timeline {
  position: relative;
  padding: 20px 0;
  list-style: none;
}

.timeline:before {
  content: ' ';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 3px;
  margin-left: -1.5px;
  background-color: #eee;
}

.timeline > li {
  position: relative;
  margin-bottom: 20px;
}

.timeline > li:before,
.timeline > li:after {
  content: ' ';
  display: table;
}

.timeline > li:after {
  clear: both;
}

.timeline > li:before,
.timeline > li:after {
  content: ' ';
  display: table;
}

.timeline > li:after {
  clear: both;
}

.timeline > li > .timeline-panel {
  float: left;
  position: relative;
  width: 46%;
  padding: 20px;
  border: 1px solid #d4d4d4;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
}

.timeline > li > .timeline-panel:before {
  content: ' ';
  display: inline-block;
  position: absolute;
  top: 26px;
  right: -15px;
  border: 15px solid transparent;
  border-right: 0 #ccc;
  border-left-color: #ccc;
}

.timeline > li > .timeline-panel:after {
  content: ' ';
  display: inline-block;
  position: absolute;
  top: 27px;
  right: -14px;
  border: 14px solid transparent;
  border-right: 0 #fff;
  border-left-color: #fff;
}

.timeline > li > .timeline-badge {
  z-index: 100;
  position: absolute;
  top: 16px;
  left: 50%;
  width: 50px;
  height: 50px;
  margin-left: -25px;
  border-radius: 50% 50% 50% 50%;
  text-align: center;
  font-size: 1.4em;
  line-height: 50px;
  color: #fff;
  background-color: #999;
}

.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}

.timeline > li.timeline-inverted > .timeline-panel:before {
  right: auto;
  left: -15px;
  border-right-width: 15px;
  border-left-width: 0;
}

.timeline > li.timeline-inverted > .timeline-panel:after {
  right: auto;
  left: -14px;
  border-right-width: 14px;
  border-left-width: 0;
}

.timeline-badge.primary {
  background-color: #2e6da4 !important;
}

.timeline-badge.success {
  background-color: #3f903f !important;
}

.timeline-badge.warning {
  background-color: #f0ad4e !important;
}

.timeline-badge.danger {
  background-color: #d9534f !important;
}

.timeline-badge.info {
  background-color: #5bc0de !important;
}

.timeline-title {
  margin-top: 0;
  color: inherit;
}

.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
}

.timeline-body > p + p {
  margin-top: 5px;
}

@media (max-width: 767px) {
  ul.timeline:before {
    left: 40px;
  }

  ul.timeline > li > .timeline-panel {
    width: calc(10%);
    width: -moz-calc(10%);
    width: -webkit-calc(10%);
  }

  ul.timeline > li > .timeline-badge {
    top: 16px;
    left: 15px;
    margin-left: 0;
  }

  ul.timeline > li > .timeline-panel {
    float: right;
  }

  ul.timeline > li > .timeline-panel:before {
    right: auto;
    left: -15px;
    border-right-width: 15px;
    border-left-width: 0;
  }

  ul.timeline > li > .timeline-panel:after {
    right: auto;
    left: -14px;
    border-right-width: 14px;
    border-left-width: 0;
  }
}

.btn-success {
  color: #fff;
  background-color: #198754;
  border-color: #198754;
  margin: 10px 5px;
}
.btn-warning {
  color: #000;
  background-color: #ffc107;
  border-color: #ffc107;
  margin: 10px 5px;
}

.btn:hover {
  cursor: pointer;
}

.navbar {
  min-height: 50px;
  padding-top: 0px;
  padding-bottom: 0px;
}

/* MenuListing Component Styles */
.menu-item {
  border-bottom: 1px solid #fff;
  width: 100%;
  padding: 5px;
  cursor: pointer;
}

.menu-item--selected {
  background-color: #FFE7FB;
  border-left: 3px solid #9F2089;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 0px;
}

.menu-item--unselected {
  /* background-color: #e9e9e9; */
}

.menu-item--external {
  /* For v2/v3 routes that use href instead of Link - no additional styles needed */
}

.menu-item__link {
  color: black;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.menu-item__link--selected {
  color: #9F2089;
}

.menu-item__link--unselected {
  color: black;
}

.menu-item__icon {
  margin-right: 4px;
}

.menu-item__icon--dashboard {
  width: 20px;
  height: 20px;
}

.menu-item__icon--default {
  width: 25px;
  height: 25px;
}

.menu-item__feature-name {
  margin-left: 4px;
  cursor: pointer;
  display: inline-block;
}

.menu-item__feature-name--selected {
  color: #9F2089;
}

.menu-item__feature-name--unselected {
  color: black;
}

/* Hover states */
.menu-item:hover {
  background-color: #FFE7FB;
}

.menu-item:hover .menu-item__link {
  color: #9F2089 !important;
  background-color: transparent;
}

.menu-item:hover .menu-item__feature-name {
  color: #9F2089 !important;
  background-color: transparent;
}

/* Menu Cards Component Styles */
.menu-cards-container {
  padding: 12px;
}

.menu-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  cursor: pointer;
  overflow: hidden;
}

.menu-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  border-color: #9F2089;
}

.menu-card--selected {
  background-color: #FFE7FB;
  border-color: #9F2089;
  border-left: 3px solid #9F2089;
}

.menu-card--unselected {
  background-color: #fff;
}

.menu-card--external {
  /* For v2/v3 routes that use href instead of Link */
}

.menu-card__link {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 12px;
  text-decoration: none;
  color: inherit;
  height: 100%;
  min-height: 100px;
}

.menu-card__link--selected {
  color: #9F2089;
}

.menu-card__link--unselected {
  color: #333;
}

.menu-card__icon-container {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #f8f9fa;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.menu-card:hover .menu-card__icon-container {
  background-color: #FFE7FB;
  transform: scale(1.05);
}

.menu-card--selected .menu-card__icon-container {
  background-color: #FFE7FB;
}

.menu-card__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.menu-card__content--selected {
  color: #9F2089;
}

.menu-card__content--unselected {
  color: #333;
}

.menu-card__title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px 0;
  line-height: 1.2;
  color: inherit;
}

.menu-card__description {
  font-size: 12px;
  color: #666;
  margin: 0;
  line-height: 1.3;
  opacity: 0.8;
}

.menu-card:hover .menu-card__description {
  opacity: 1;
}

.menu-card--selected .menu-card__description {
  color: #9F2089;
  opacity: 0.9;
}

/* Responsive design */
@media (max-width: 768px) {
  .menu-cards-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 10px;
  }
  
  .menu-cards-container {
    padding: 10px;
  }
  
  .menu-card__link {
    padding: 14px 10px;
    min-height: 90px;
  }
  
  .menu-card__icon-container {
    width: 32px;
    height: 32px;
  }
  
  .menu-card__title {
    font-size: 13px;
  }
  
  .menu-card__description {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .menu-cards-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 8px;
  }
  
  .menu-cards-container {
    padding: 8px;
  }
  
  .menu-card__link {
    padding: 12px 8px;
    min-height: 80px;
  }
  
  .menu-card__icon-container {
    width: 28px;
    height: 28px;
  }
  
  .menu-card__title {
    font-size: 12px;
  }
  
  .menu-card__description {
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/sb-admin.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,4DAA4D;IAC5D,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["body {\n  /* color: #52616a; */\n  min-height: 100vh;\n}\n\n.text-color {\n  color: #52616a;\n  overflow-wrap: break-word;\n}\n\n.modal-title {\n  color: #52616a;\n}\n\n#welcome-screen nav {\n  margin-bottom: 0;\n}\n\n.background-white {\n  background: #fff;\n}\n\n.border-radius {\n  border-radius: 0;\n}\n\n.navbar-brand {\n  color: #fff !important;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.navbar-default {\n  background: #fff;\n  border: none;\n  margin: 0;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  color: #000;\n}\n\n.navbar-default-new {\n  background: #fff;\n  border: none;\n  margin: 0;\n}\n\n.navbar-default-new .navbar-nav > li > a {\n  color: #000;\n  font-weight: 700;\n}\n\n.navbar-default-new .navbar-nav > li > a:hover {\n  color: rgb(159, 32, 137);\n  background-color: #FFE7FB;\n}\n\n.navbar-default-new .navbar-nav > li > a:focus {\n  color: rgb(159, 32, 137);\n}\n\n.navbar-default .navbar-nav > li > a {\n  color: #fff;\n  font-weight: 700;\n}\n\n.navbar-default .navbar-nav > li > a:hover {\n  color: #fff;\n}\n\n#wrapper,\n.container {\n  width: 100%;\n  /* background-color: #f5f5f5; */\n}\n\n.navbar-static-top {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1001;\n}\n\n.page-header {\n  margin-top: 20px;\n  font-size: 30px;\n}\n\n#wrapper nav {\n  margin-bottom: 0;\n}\n\n.navbar-header {\n  width: 180px;\n}\n\n.toggle-button {\n  padding: 8px 10px;\n  border-left: 1px solid #fff;\n}\n\n.sidebar {\n  z-index: 1;\n  position: absolute;\n  /* border-top: 1px solid #fff; */\n  width: 180px;\n  height: 100vh;\n  overflow: scroll;\n  padding-bottom: 60px;\n  overflow-y: scroll;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-open {\n  left: 0;\n  top: 53px;\n}\n\n.sidebar-close {\n  left: -180px;\n}\n\n.no-features-found {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: #de7b7b;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n}\n\n#menu_toggle {\n  cursor: pointer;\n  background: #fff;\n  border: none;\n  border-radius: 4px;\n  text-align: center;\n  padding: 4px 8px;\n}\n\n#menu_toggle .fa-bars {\n  font-size: 18px;\n}\n\n#page-wrapper {\n  min-height: calc(100vh);\n  position: inherit;\n  margin: 0 0 0 180px;\n  padding: 52px 15px 30px;\n  background-color: #f5f5f5;\n}\n\n#mt-16 {\n  margin-top: 52px;\n}\n#wrapper.sidebarClosed #page-wrapper {\n  margin: 0;\n}\n\n.padding-bottom-0 {\n  padding-bottom: 0 !important;\n}\n\n.navbar-top-links {\n  margin-right: 0;\n}\n\n.navbar-top-links li {\n  display: inline-block;\n}\n\n.navbar-top-links li:last-child {\n  margin-right: 15px;\n}\n\n.navbar-top-links li a {\n  padding: 15px;\n  min-height: 50px;\n  font-size: 14px;\n}\n\n.navbar-top-links .dropdown-menu li {\n  display: block;\n}\n\n.navbar-top-links .dropdown-menu li:last-child {\n  margin-right: 0;\n}\n\n.menu-items-list ul {\n  list-style: none;\n  /* padding: 4px; */\n}\n\n.feature-name {\n  margin-left: 4px;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.feature-name:hover {\n  margin-left: 4px;\n  border: none !important;\n  background-color: #fff;\n}\n\n.menu-items-list a:hover {\n  background-color: #fff;\n  /* color: #9F2089; */\n}\n\n.navbar-top-links .dropdown-menu li a {\n  padding: 3px 20px;\n  min-height: 0;\n}\n\n.navbar-top-links .dropdown-menu li a div {\n  white-space: normal;\n}\n\n.navbar-top-links .dropdown-messages,\n.navbar-top-links .dropdown-tasks,\n.navbar-top-links .dropdown-alerts {\n  width: 310px;\n  min-width: 0;\n}\n\n.navbar-top-links .dropdown-messages {\n  margin-left: 5px;\n}\n\n.navbar-top-links .dropdown-tasks {\n  margin-left: -59px;\n}\n\n.navbar-top-links .dropdown-alerts {\n  margin-left: -123px;\n}\n\n.navbar-top-links .dropdown-user {\n  right: 0;\n  left: auto;\n}\n\n.sidebar .sidebar-nav.navbar-collapse {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.sidebar .sidebar-search {\n  padding: 15px;\n}\n\n.sidebar ul li {\n  border-bottom: 1px solid #fff;\n  width: 100%;\n  padding: 4px;\n}\n\n.sidebar ul li a {\n  color: #fff;\n  font-size: 14px;\n}\n\n.sidebar ul li a:hover {\n  background-color: rgb(159, 32, 137);\n  color: #fff;\n}\n\n.sidebar ul li a.active {\n  background-color: #fff;\n  color: rgb(159, 32, 137);\n  font-weight: 700;\n}\n\n.sidebar .arrow {\n  float: right;\n}\n\n.sidebar .fa.arrow:before {\n  content: '\\f104';\n}\n\n.sidebar .active > a > .fa.arrow:before {\n  content: '\\f107';\n}\n\n.sidebar .nav-second-level li,\n.sidebar .nav-third-level li {\n  border-bottom: none !important;\n}\n\n.sidebar .nav-second-level li a {\n  padding-left: 37px;\n}\n\n.sidebar .nav-third-level li a {\n  padding-left: 52px;\n}\n\n.navbar-top-links .dropdown-messages,\n.navbar-top-links .dropdown-tasks,\n.navbar-top-links .dropdown-alerts {\n  margin-left: auto;\n}\n\n.btn-outline {\n  color: inherit;\n  background-color: transparent;\n  transition: all 0.5s;\n}\n\n.btn-primary.btn-outline {\n  color: #428bca;\n}\n\n.btn-primary.btn-custom {\n  color: #306CF5;\n  background: #fff;\n}\n\n.btn-success.btn-outline {\n  color: #5cb85c;\n}\n\n.btn-info.btn-outline {\n  color: #5bc0de;\n}\n\n.btn-warning.btn-outline {\n  color: #f0ad4e;\n}\n\n.btn-danger.btn-outline {\n  color: #d9534f;\n}\n\n.btn-primary.btn-outline:hover,\n.btn-success.btn-outline:hover,\n.btn-info.btn-outline:hover,\n.btn-warning.btn-outline:hover,\n.btn-danger.btn-outline:hover {\n  color: #fff;\n}\n\n.chat {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.chat li {\n  margin-bottom: 10px;\n  padding-bottom: 5px;\n  border-bottom: 1px dotted #999;\n}\n\n.chat li.left .chat-body {\n  margin-left: 60px;\n}\n\n.chat li.right .chat-body {\n  margin-right: 60px;\n}\n\n.chat li .chat-body p {\n  margin: 0;\n}\n\n.panel .slidedown .glyphicon,\n.chat .glyphicon {\n  margin-right: 5px;\n}\n\n.chat-panel .panel-body {\n  height: 350px;\n  overflow-y: scroll;\n}\n\n.login-panel {\n  margin-top: 50px;\n}\n\n.flot-chart {\n  display: block;\n  height: 400px;\n}\n\n.flot-chart-content {\n  width: 100%;\n  height: 100%;\n}\n\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n  background: transparent;\n}\n\ntable.dataTable thead .sorting_asc:after {\n  content: '\\f0de';\n  float: right;\n  font-family: fontawesome;\n}\n\ntable.dataTable thead .sorting_desc:after {\n  content: '\\f0dd';\n  float: right;\n  font-family: fontawesome;\n}\n\ntable.dataTable thead .sorting:after {\n  content: '\\f0dc';\n  float: right;\n  font-family: fontawesome;\n  color: rgba(50, 50, 50, 0.5);\n}\n\n.btn-circle {\n  width: 30px;\n  height: 30px;\n  padding: 6px 0;\n  border-radius: 15px;\n  text-align: center;\n  font-size: 12px;\n  line-height: 1.428571429;\n}\n\n.btn-circle.btn-lg {\n  width: 50px;\n  height: 50px;\n  padding: 10px 16px;\n  border-radius: 25px;\n  font-size: 18px;\n  line-height: 1.33;\n}\n\n.btn-circle.btn-xl {\n  width: 70px;\n  height: 70px;\n  padding: 10px 16px;\n  border-radius: 35px;\n  font-size: 24px;\n  line-height: 1.33;\n}\n\n.show-grid [class^='col-'] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border: 1px solid #ddd;\n  background-color: #eee !important;\n}\n\n.show-grid {\n  margin: 15px 0;\n}\n\n.huge {\n  font-size: 40px;\n}\n\n.panel-green {\n  border-color: #5cb85c;\n}\n\n.panel-green > .panel-heading {\n  border-color: #5cb85c;\n  color: #fff;\n  background-color: #5cb85c;\n}\n\n.panel-green > a {\n  color: #5cb85c;\n}\n\n.panel-green > a:hover {\n  color: #3d8b3d;\n}\n\n.panel-red {\n  border-color: #d9534f;\n}\n\n.panel-red > .panel-heading {\n  border-color: #d9534f;\n  color: #fff;\n  background-color: #d9534f;\n}\n\n.panel-red > a {\n  color: #d9534f;\n}\n\n.panel-red > a:hover {\n  color: #b52b27;\n}\n\n.panel-yellow {\n  border-color: #f0ad4e;\n}\n\n.panel-yellow > .panel-heading {\n  border-color: #f0ad4e;\n  color: #fff;\n  background-color: #f0ad4e;\n}\n\n.panel-yellow > a {\n  color: #f0ad4e;\n}\n\n.panel-yellow > a:hover {\n  color: #df8a13;\n}\n\n.timeline {\n  position: relative;\n  padding: 20px 0;\n  list-style: none;\n}\n\n.timeline:before {\n  content: ' ';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  width: 3px;\n  margin-left: -1.5px;\n  background-color: #eee;\n}\n\n.timeline > li {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.timeline > li:before,\n.timeline > li:after {\n  content: ' ';\n  display: table;\n}\n\n.timeline > li:after {\n  clear: both;\n}\n\n.timeline > li:before,\n.timeline > li:after {\n  content: ' ';\n  display: table;\n}\n\n.timeline > li:after {\n  clear: both;\n}\n\n.timeline > li > .timeline-panel {\n  float: left;\n  position: relative;\n  width: 46%;\n  padding: 20px;\n  border: 1px solid #d4d4d4;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);\n}\n\n.timeline > li > .timeline-panel:before {\n  content: ' ';\n  display: inline-block;\n  position: absolute;\n  top: 26px;\n  right: -15px;\n  border: 15px solid transparent;\n  border-right: 0 #ccc;\n  border-left-color: #ccc;\n}\n\n.timeline > li > .timeline-panel:after {\n  content: ' ';\n  display: inline-block;\n  position: absolute;\n  top: 27px;\n  right: -14px;\n  border: 14px solid transparent;\n  border-right: 0 #fff;\n  border-left-color: #fff;\n}\n\n.timeline > li > .timeline-badge {\n  z-index: 100;\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  width: 50px;\n  height: 50px;\n  margin-left: -25px;\n  border-radius: 50% 50% 50% 50%;\n  text-align: center;\n  font-size: 1.4em;\n  line-height: 50px;\n  color: #fff;\n  background-color: #999;\n}\n\n.timeline > li.timeline-inverted > .timeline-panel {\n  float: right;\n}\n\n.timeline > li.timeline-inverted > .timeline-panel:before {\n  right: auto;\n  left: -15px;\n  border-right-width: 15px;\n  border-left-width: 0;\n}\n\n.timeline > li.timeline-inverted > .timeline-panel:after {\n  right: auto;\n  left: -14px;\n  border-right-width: 14px;\n  border-left-width: 0;\n}\n\n.timeline-badge.primary {\n  background-color: #2e6da4 !important;\n}\n\n.timeline-badge.success {\n  background-color: #3f903f !important;\n}\n\n.timeline-badge.warning {\n  background-color: #f0ad4e !important;\n}\n\n.timeline-badge.danger {\n  background-color: #d9534f !important;\n}\n\n.timeline-badge.info {\n  background-color: #5bc0de !important;\n}\n\n.timeline-title {\n  margin-top: 0;\n  color: inherit;\n}\n\n.timeline-body > p,\n.timeline-body > ul {\n  margin-bottom: 0;\n}\n\n.timeline-body > p + p {\n  margin-top: 5px;\n}\n\n@media (max-width: 767px) {\n  ul.timeline:before {\n    left: 40px;\n  }\n\n  ul.timeline > li > .timeline-panel {\n    width: calc(10%);\n    width: -moz-calc(10%);\n    width: -webkit-calc(10%);\n  }\n\n  ul.timeline > li > .timeline-badge {\n    top: 16px;\n    left: 15px;\n    margin-left: 0;\n  }\n\n  ul.timeline > li > .timeline-panel {\n    float: right;\n  }\n\n  ul.timeline > li > .timeline-panel:before {\n    right: auto;\n    left: -15px;\n    border-right-width: 15px;\n    border-left-width: 0;\n  }\n\n  ul.timeline > li > .timeline-panel:after {\n    right: auto;\n    left: -14px;\n    border-right-width: 14px;\n    border-left-width: 0;\n  }\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #198754;\n  border-color: #198754;\n  margin: 10px 5px;\n}\n.btn-warning {\n  color: #000;\n  background-color: #ffc107;\n  border-color: #ffc107;\n  margin: 10px 5px;\n}\n\n.btn:hover {\n  cursor: pointer;\n}\n\n.navbar {\n  min-height: 50px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n\n/* MenuListing Component Styles */\n.menu-item {\n  border-bottom: 1px solid #fff;\n  width: 100%;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.menu-item--selected {\n  background-color: #FFE7FB;\n  border-left: 3px solid #9F2089;\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 0px;\n}\n\n.menu-item--unselected {\n  /* background-color: #e9e9e9; */\n}\n\n.menu-item--external {\n  /* For v2/v3 routes that use href instead of Link - no additional styles needed */\n}\n\n.menu-item__link {\n  color: black;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n}\n\n.menu-item__link--selected {\n  color: #9F2089;\n}\n\n.menu-item__link--unselected {\n  color: black;\n}\n\n.menu-item__icon {\n  margin-right: 4px;\n}\n\n.menu-item__icon--dashboard {\n  width: 20px;\n  height: 20px;\n}\n\n.menu-item__icon--default {\n  width: 25px;\n  height: 25px;\n}\n\n.menu-item__feature-name {\n  margin-left: 4px;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.menu-item__feature-name--selected {\n  color: #9F2089;\n}\n\n.menu-item__feature-name--unselected {\n  color: black;\n}\n\n/* Hover states */\n.menu-item:hover {\n  background-color: #FFE7FB;\n}\n\n.menu-item:hover .menu-item__link {\n  color: #9F2089 !important;\n  background-color: transparent;\n}\n\n.menu-item:hover .menu-item__feature-name {\n  color: #9F2089 !important;\n  background-color: transparent;\n}\n\n/* Menu Cards Component Styles */\n.menu-cards-container {\n  padding: 12px;\n}\n\n.menu-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 12px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.menu-card {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.menu-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  border-color: #9F2089;\n}\n\n.menu-card--selected {\n  background-color: #FFE7FB;\n  border-color: #9F2089;\n  border-left: 3px solid #9F2089;\n}\n\n.menu-card--unselected {\n  background-color: #fff;\n}\n\n.menu-card--external {\n  /* For v2/v3 routes that use href instead of Link */\n}\n\n.menu-card__link {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 16px 12px;\n  text-decoration: none;\n  color: inherit;\n  height: 100%;\n  min-height: 100px;\n}\n\n.menu-card__link--selected {\n  color: #9F2089;\n}\n\n.menu-card__link--unselected {\n  color: #333;\n}\n\n.menu-card__icon-container {\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background-color: #f8f9fa;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.menu-card:hover .menu-card__icon-container {\n  background-color: #FFE7FB;\n  transform: scale(1.05);\n}\n\n.menu-card--selected .menu-card__icon-container {\n  background-color: #FFE7FB;\n}\n\n.menu-card__content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.menu-card__content--selected {\n  color: #9F2089;\n}\n\n.menu-card__content--unselected {\n  color: #333;\n}\n\n.menu-card__title {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  line-height: 1.2;\n  color: inherit;\n}\n\n.menu-card__description {\n  font-size: 12px;\n  color: #666;\n  margin: 0;\n  line-height: 1.3;\n  opacity: 0.8;\n}\n\n.menu-card:hover .menu-card__description {\n  opacity: 1;\n}\n\n.menu-card--selected .menu-card__description {\n  color: #9F2089;\n  opacity: 0.9;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .menu-cards-grid {\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 10px;\n  }\n  \n  .menu-cards-container {\n    padding: 10px;\n  }\n  \n  .menu-card__link {\n    padding: 14px 10px;\n    min-height: 90px;\n  }\n  \n  .menu-card__icon-container {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .menu-card__title {\n    font-size: 13px;\n  }\n  \n  .menu-card__description {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 480px) {\n  .menu-cards-grid {\n    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n    gap: 8px;\n  }\n  \n  .menu-cards-container {\n    padding: 8px;\n  }\n  \n  .menu-card__link {\n    padding: 12px 8px;\n    min-height: 80px;\n  }\n  \n  .menu-card__icon-container {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .menu-card__title {\n    font-size: 12px;\n  }\n  \n  .menu-card__description {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
